import styled from '@emotion/styled/macro';

export const Wrapper = styled.div`
  color: ${({ theme }) => theme.color.dark1};
  display: flex;
  gap: 0.6rem;
  align-items: center;
`;
